import { useIsAppControl } from '@store/isApp'
import { useGetIsMobile } from '@store/isMobile'
import { useLocalStorage } from './useLocalStorage'

const useMobileDisabled = () => {
	const { isApp } = useIsAppControl()
	const isMobile = useGetIsMobile()
	const [networkYn] = useLocalStorage<boolean>('network_yn')

	return isApp && isMobile && !networkYn
}
export default useMobileDisabled
